module.exports = __webpack_public_path__ + "img/bg_map.2a726c33.jpg";